import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { WooTabComponent } from '../../../src/shared/navigation/woo-tabs/woo-tab/woo-tab.component';
import { WooTabsComponent } from '../../../src/shared/navigation/woo-tabs/woo-tabs.component';
import { ManageAdvancedTargetGroups } from '../components/products_page/advanced_target_groups/manage-advanced-target-groups.component';
import { ManageAgWithdrawalLimits } from '../components/products_page/ag_withdrawal_limit/manage-ag-withdrawal-limits.component';
import { ManageBehaviors } from '../components/products_page/behaviors/manage-behaviors.component';
import { ManageCategories } from '../components/products_page/categories/manage-categories.component';
import { ManageCompletionRatesEstimates } from '../components/products_page/completed_views/manage-completion-rates-estimates.component';
import { ManageDayparts } from '../components/products_page/dayparts/manage-dayparts.component';
import { ManageDefaultFrequencyLimits } from '../components/products_page/default_frequency_limits/manage-default-frequency-limits.component';
import { ManageDeviceGroups } from '../components/products_page/device_groups/manage-device-groups.component';
import { ManageDevices } from '../components/products_page/devices/manage-devices.component';
import { ManageFrequencyLimits } from '../components/products_page/frequency_limit/manage-frequency-limits.component';
import { ManageGamblingEstimates } from '../components/products_page/gambling/manage-gambling-estimates.component';
import { ManageGrossRatingFactor } from '../components/products_page/gross_rating_views/manage-gross-rating-factor.component';
import { ManagePauseAdEstimates } from '../components/products_page/pause_ad/manage-pause-ad-estimates.component';
import { ManagePriceLists } from '@scripts/product_management.module/components/products_page/pricelists/manage-pricelists/manage-pricelists.component';
import { ManageProductFormatShares } from '../components/products_page/product_formats/manage-product-formats-shares';
import { ManageProgramFormats } from '@scripts/product_management.module/components/products_page/program_formats/manage-program-formats/manage-program-formats.component';
import { ManageRegions } from '../components/products_page/regions/manage-regions.component';
import { ManageTargetGroups } from '../components/products_page/target_groups/manage-target-groups.component';
import { ManageUniverse } from '../components/products_page/universe/manage-universe.component';

@Component({
  selector: 'woo-products-page',
  imports: [WooTabComponent, WooTabsComponent, CommonModule],
  templateUrl: './products-page.component.html',
  styleUrls: ['./products-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductsPageComponent {
  inventoryVisible: boolean = true;

  //Tab 1 Component inclusions.
  ManageGrossRatingFactor = ManageGrossRatingFactor;
  ManageGamblingEstimates = ManageGamblingEstimates;
  ManageProductFormatShares = ManageProductFormatShares;
  ManagePauseAdEstimates = ManagePauseAdEstimates;
  ManageCategories = ManageCategories;
  ManageFrequencyLimits = ManageFrequencyLimits;
  ManageCompletionRatesEstimates = ManageCompletionRatesEstimates;
  ManageAgWithdrawalLimits = ManageAgWithdrawalLimits;

  //Tab 2 Component inclusions.
  ManageDeviceGroups = ManageDeviceGroups;
  ManageAdvancedTargetGroups = ManageAdvancedTargetGroups;
  ManageBehaviors = ManageBehaviors;
  ManageDayparts = ManageDayparts;
  ManageTargetGroups = ManageTargetGroups;
  ManageProgramFormats = ManageProgramFormats;
  ManageRegions = ManageRegions;

  //Tab 3 Component inclusions.
  ManageDevices = ManageDevices;
  ManagePriceLists = ManagePriceLists;
  ManageUniverse = ManageUniverse;
  ManageDefaultFrequencyLimits = ManageDefaultFrequencyLimits;
}
